import { useI18n } from 'vue-i18n';

type TConnectionPointType = 'stakeholder' | 'not_stakeholder';
type TConnectionPoint = {
  value: TConnectionPointType;
  name: string;
};

const useCallConnectionPoints = () => {

  const i18n = useI18n();

  const callConnectionPoints: TConnectionPoint[] = [
    {
      value: 'stakeholder',
      name: i18n.t('callResult.connectedTo.enum.stakeholder'),
    },
    {
      value: 'not_stakeholder',
      name: i18n.t('callResult.connectedTo.enum.notStakeholder'),
    },
  ];

  return {
    callConnectionPoints,
  };
};

export default useCallConnectionPoints;
